import { render, staticRenderFns } from "./BoutonUndo.vue?vue&type=template&id=b305935a&scoped=true&"
import script from "./BoutonUndo.vue?vue&type=script&lang=js&"
export * from "./BoutonUndo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b305935a",
  null
  
)

export default component.exports